// import React, { useEffect, useState } from "react";
// import SearchIcon from "@mui/icons-material/Search";
// import saleService from "../../Services/saleService";
// import DoctorSalesModal from "../../Components/DoctorSalesModal"; // Import the modal

// const DoctorIncome = () => {
//   const [searchData, setSearchData] = useState("");
//   const [filteredData, setFilteredData] = useState([]);
//   const [paginatedData, setPaginatedData] = useState([]);
//   const [itemsPerPage] = useState(10);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [doctors, setDoctors] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selectedDoctor, setSelectedDoctor] = useState(null);
//   const [doctorSales, setDoctorSales] = useState([]);

//   useEffect(() => {
//     const getPSales = async () => {
//       try {
//         setLoading(true);
//         const response = await saleService.fetchAllPSales();

//         const groupedDoctors = response.sales.reduce((acc, sale) => {
//           if (!acc[sale.name]) {
//             acc[sale.name] = {
//               name: sale.name,
//               specialization: sale.specialization,
//               fee: sale.fee,
//               pay: sale.pay,
//               commission: sale.commission,
//               sales: [],
//             };
//           }
//           acc[sale.name].sales.push(sale);
//           return acc;
//         }, {});

//         setDoctors(Object.values(groupedDoctors));
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         console.error("Error fetching sales:", error);
//       }
//     };
//     getPSales();
//   }, []);

//   useEffect(() => {
//     const filteredResult =
//       doctors.filter((item) =>
//         item.name.toLowerCase().includes(searchData.toLowerCase())
//       ) || [];
//     setFilteredData(filteredResult);
//     setCurrentPage(1);
//   }, [searchData, doctors]);

//   useEffect(() => {
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     setPaginatedData(filteredData.slice(startIndex, endIndex));
//   }, [currentPage, filteredData]);

//   return (
//     <div>
//       <div className="p-4">
//         <h1 className="ml-[3%] text-[19px] text-gray-700 font-[700]">
//           Manage Sales Record
//         </h1>
//         <h1 className="ml-[3%] text-[13px] text-gray-700 mb-4">
//           {filteredData.length || 0} records found
//         </h1>

//         <div className="flex mt-8 flex-row-reverse justify-between px-[3%]">
//           <div className="w-[40%]">
//             <input
//               type="search"
//               placeholder="Search Here..."
//               value={searchData}
//               onChange={(e) => setSearchData(e.target.value)}
//               className="block w-[90%] pl-10 text-gray-900 p-2 rounded-md border-gray-800 bg-white focus:outline-none"
//             />
//             <SearchIcon className="mt-[-4rem] text-gray-700 ml-2" />
//           </div>
//         </div>

//         <div className="mx-[3%]">
//           <table className="w-[100%] rounded-xl overflow-hidden">
//             <thead>
//               <tr className="bg-gray-700 text-white text-left text-xs capitalize leading-normal">
//                 <th className="py-4 w-[6%] pl-4">
//                   Sr No.
//                 </th>
//                 <th className="py-4 w-[20%] pl-4">
//                   Doctor
//                 </th>
//                 <th className="py-4 w-[20%] pl-4">
//                   Specialization
//                 </th>
//                 <th className="py-4 w-[15%] text-center">
//                   Fee
//                 </th>
//                 <th className="py-4 w-[15%] text-center">
//                   Pay
//                 </th>
//                 <th className="py-4 w-[10%] text-center">
//                   Commission
//                 </th>
//                 <th className="py-4 w-[15%] text-center">
//                   Action
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedData.map((doctor, index) => (
//                 <tr
//                   key={index}
//                   className="bg-white text-xs border-t-[1px] border-gray-200"
//                 >
//                   <td className="py-4 w-[6%] text-left font-bold pl-4">
//                       {index + 1}.
//                   </td>
//                   <td className="w-[20%] text-left font-bold pl-4">
//                       {doctor.name}
//                   </td>
//                   <td className="w-[20%] text-left pl-4">
//                       {doctor.specialization}
//                   </td>
//                   <td className="px-2 w-[15%] text-center">
//                     {doctor.fee}
//                   </td>
//                   <td className="px-2 w-[15%] text-center">
//                     {doctor.pay}
//                   </td>
//                   <td className="px-2 w-[10%] text-center">
//                     {doctor.commission}
//                   </td>
//                   <td className="px-2 w-[15%] text-center">
//                     <button
//                       className="text-[13px] font-[500] text-blue-500"
//                       onClick={() => {
//                         setSelectedDoctor(doctor.name);
//                         setDoctorSales(doctor.sales);
//                       }}
//                     >
//                       View
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         {selectedDoctor && (
//           <DoctorSalesModal
//             doctor={selectedDoctor}
//             sales={doctorSales}
//             onClose={() => setSelectedDoctor(null)}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default DoctorIncome;
import React, { useEffect, useState } from "react";
import saleService from "../../Services/saleService";
import DoctorSalesModal from "../../Components/DoctorSalesModal";
import PaginationComponent from "../../Components/PaginationComponent";

const DoctorIncome = () => {
  const [searchData, setSearchData] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [doctorSales, setDoctorSales] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    const getPSales = async () => {
      try {
        setLoading(true);
        const response = await saleService.fetchAllPSales();
        const grouped = response.sales.reduce((acc, sale) => {
          if (!acc[sale.name]) {
            acc[sale.name] = {
              name: sale.name,
              specialization: sale.specialization,
              fee: sale.fee,
              pay: sale.pay,
              commission: sale.commission,
              sales: [],
            };
          }
          acc[sale.name].sales.push(sale);
          return acc;
        }, {});
        setDoctors(Object.values(grouped));
      } catch (error) {
        console.error("Error fetching sales:", error);
      } finally {
        setLoading(false);
      }
    };
    getPSales();
  }, []);

  useEffect(() => {
    const result = doctors.filter((item) =>
      item.name.toLowerCase().includes(searchData.toLowerCase()),
    );
    setFilteredData(result);
    setCurrentPage(1);
  }, [searchData, doctors]);

  useEffect(() => {
    const start = (currentPage - 1) * itemsPerPage;
    setPaginatedData(filteredData.slice(start, start + itemsPerPage));
  }, [currentPage, filteredData]);

  const handleView = (doctor) => {
    setSelectedDoctor(doctor.name);
    setDoctorSales(doctor.sales);
  };

  // Desktop column widths
  const colWidths = [
    "70px",
    "150px",
    "150px",
    "100px",
    "100px",
    "100px",
    "100px",
  ];
  const ColGroup = () => (
    <colgroup>
      {colWidths.map((w, i) => (
        <col key={i} style={{ width: w, minWidth: w }} />
      ))}
    </colgroup>
  );

  return (
    <div className="p-3 sm:p-4 font-sans">
      {/* ── Header ── */}
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div>
          <p className="text-xs font-medium tracking-widest uppercase text-gray-500">
            Doctor Income
          </p>
          <p className="text-[11px] text-gray-400 mt-0.5">
            {filteredData.length || 0} records found
          </p>
        </div>
      </div>

      {/* ── Search ── */}
      <div className="relative mb-4">
        <svg
          className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z"
          />
        </svg>
        <input
          type="search"
          placeholder="Search by doctor name..."
          value={searchData}
          onChange={(e) => setSearchData(e.target.value)}
          className="w-full sm:w-72 pl-9 pr-4 py-2 text-xs border border-gray-200 rounded-lg bg-white
            text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-blue-100"
        />
      </div>

      {/* ══ MOBILE CARDS (< sm) ══ */}
      <div className="block sm:hidden space-y-2">
        {loading ? (
          <div className="text-center py-10 text-gray-400 text-xs">
            Loading...
          </div>
        ) : paginatedData.length === 0 ? (
          <div className="text-center py-10 text-gray-400 text-xs">
            No records found
          </div>
        ) : (
          paginatedData.map((doctor, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-xl bg-white px-3 py-3"
            >
              {/* Card top */}
              <div className="flex items-center gap-2 mb-2">
                <div
                  className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center
                  text-[11px] font-semibold text-gray-600 uppercase flex-shrink-0"
                >
                  {doctor?.name?.charAt(0) || "D"}
                </div>
                <div>
                  <p className="text-[12px] font-semibold text-gray-800">
                    {doctor?.name}
                  </p>
                  <p className="text-[10px] text-gray-400">
                    {doctor?.specialization}
                  </p>
                </div>
              </div>
              {/* Stats row */}
              <div className="grid grid-cols-3 gap-2 mb-2">
                {[
                  { label: "Fee", value: doctor?.fee },
                  { label: "Pay", value: doctor?.pay },
                  { label: "Commission", value: doctor?.commission },
                ].map(({ label, value }) => (
                  <div
                    key={label}
                    className="bg-gray-50 rounded-lg px-2 py-1.5 text-center"
                  >
                    <p className="text-[9px] uppercase tracking-wide text-gray-400">
                      {label}
                    </p>
                    <p className="text-[11px] font-semibold text-gray-800 mt-0.5">
                      {value ?? "—"}
                    </p>
                  </div>
                ))}
              </div>
              {/* View button */}
              <button
                onClick={() => handleView(doctor)}
                className="w-full py-1.5 text-[11px] font-semibold rounded-lg border border-gray-200
                  text-gray-600 hover:bg-gray-50 transition"
              >
                View Sales
              </button>
            </div>
          ))
        )}
      </div>

      {/* ══ DESKTOP TABLE (>= sm) ══ */}
      <div className="hidden sm:block border rounded-xl overflow-hidden">
        <div className="overflow-y-auto" style={{ maxHeight: "520px" }}>
          <table
            className="w-full text-sm"
            style={{
              tableLayout: "fixed",
              borderCollapse: "separate",
              borderSpacing: 0,
            }}
          >
            <ColGroup />
            <thead>
              <tr>
                {[
                  "Sr No.",
                  "Doctor",
                  "Specialization",
                  "Fee",
                  "Pay",
                  "Commission",
                  "Action",
                ].map((label, i) => (
                  <th
                    key={label}
                    className={`sticky top-0 z-20 bg-[#215187] text-left px-4 py-2.5 text-[11px]
                      text-gray-100 uppercase font-medium
                      ${i < 6 ? "border-r border-white/10" : ""}`}
                  >
                    {label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td
                    colSpan={7}
                    className="text-center py-10 text-gray-400 text-[12px]"
                  >
                    Loading...
                  </td>
                </tr>
              ) : paginatedData.length === 0 ? (
                <tr>
                  <td
                    colSpan={7}
                    className="text-center py-10 text-gray-400 text-[12px]"
                  >
                    No records found
                  </td>
                </tr>
              ) : (
                paginatedData.map((doctor, index) => (
                  <tr
                    key={index}
                    className={`border-b border-gray-100 hover:bg-green-50 transition-colors ${index % 2 ? "bg-gray-50" : "bg-white"}`}
                  >
                    <td className="px-4 py-2.5 text-[12px] font-semibold text-gray-500 border-r border-gray-100">
                      {index + 1}.
                    </td>
                    <td className="px-4 py-2.5 border-r border-gray-100">
                      <div className="flex items-center gap-2">
                        {/* <div
                          className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center
                          text-[10px] font-semibold text-gray-600 uppercase flex-shrink-0"
                        >
                          {doctor?.name?.charAt(0) || "D"}
                        </div> */}
                        <span className="text-[12px] font-medium text-gray-800 truncate">
                          {doctor?.name}
                        </span>
                      </div>
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100 truncate">
                      {doctor?.specialization}
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100">
                      {doctor?.fee}
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100">
                      {doctor?.pay}
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100">
                      {doctor?.commission}
                    </td>
                    <td className="px-4 py-2.5 text-[12px]">
                      <button
                        onClick={() => handleView(doctor)}
                        className="text-[11px] font-medium text-white bg-[#2F6DB4] px-2.5 py-1 rounded-lg hover:bg-[#255A8C] transition"
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
            <tfoot>
              <tr>
                <td
                  colSpan={7}
                  className="sticky bottom-0 z-20 bg-[#215187] px-4 py-2.5 text-[12px]
                    font-medium text-gray-100 border-t border-white/10"
                >
                  {filteredData.length || 0} total records
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      {/* ── Pagination ── */}
      {/* <div className="mt-3">
        <PaginationComponent
          filteredData={filteredData}
          setPaginatedData={setPaginatedData}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div> */}

      {/* Sales modal */}
      {selectedDoctor && (
        <DoctorSalesModal
          doctor={selectedDoctor}
          sales={doctorSales}
          onClose={() => setSelectedDoctor(null)}
        />
      )}
    </div>
  );
};

export default DoctorIncome;
